/* eslint-disable no-underscore-dangle */
import React, { useEffect, useState } from 'react';

import { Layout } from 'antd';

import { apiPostData } from '../../../../api';
import GTooltip from '../../../components/GTooltip/GTooltip';
import styles from './styles.scss';
import W3AvailableEventCard from './W3AvailableEventCard';

export default function WebinarEventsAvailableList() {
  const [eventsList, setEventsList] = useState([]);

  const fetchList = async () => {
    const { list } = await apiPostData('/webinars3/user/event/list', { state: 2 });
    setEventsList(list);
  };

  useEffect(() => {
    fetchList();
  }, []);

  return (
    <>
      <div className={styles.pageHeader}>
        <GTooltip tid="webinars_preson_events_available">
          Доступные для записи вебинары, семинары
        </GTooltip>
      </div>

      <Layout.Content>
        <div className={styles.contextHolder}>
          {eventsList.map((it) => (
            <W3AvailableEventCard key={it.__event._id} event={it.__event} />
          ))}
        </div>
      </Layout.Content>
    </>
  );
}
